import * as React from 'react';

// API
import apibridge from '../../apibridge';

// UTILS
import { validationErrorsToString } from '../../utils';

// PACKAGES
import { SwitchTransition, CSSTransition } from 'react-transition-group';
import { useHistory } from 'react-router-dom';

// COMPONENTS
import Button from '../../components/Button';
import LoadingSpinner from '../../components/LoadingSpinner';

// ICONS
import { ReactComponent as AlertIcon } from '../../assets/svg/alert.svg';

// TYPES
import { FamiliesDisableProfileCommand } from '../../api/models';
import { closeModalType } from '../../components/GlobalModal';

interface RemoveFamiliesMemberModalTypes {
	familiesMemberId?: string;
	closeModal?: closeModalType;
	getFamiliesProfileData: () => Promise<void>;
	firstName?: string;
	lastName?: string;
}

const RemoveFamiliesMemberModal: React.FC<RemoveFamiliesMemberModalTypes> = ({
	familiesMemberId,
	closeModal,
	getFamiliesProfileData,
	firstName,
	lastName
}) => {
	const history = useHistory();

	// Error and Loading state
	const [formErrorMessage, setFormErrorMessage] = React.useState<string>('');

	const [isLoading, setIsLoading] = React.useState<boolean>(false);

	const confirmRemove = async () => {
		setIsLoading(true);

		const data: FamiliesDisableProfileCommand = { id: familiesMemberId };

		const response = await apibridge.disableFamilyMember(data);

		if (response.isError) {
			setIsLoading(false);

			setFormErrorMessage(
				response.validationErrors.length
					? validationErrorsToString(response.validationErrors)
					: response.message || 'An error has occurred'
			);
		} else {
			setIsLoading(false);

			if (closeModal) {
				closeModal();
			}

			history.push('/families');

			getFamiliesProfileData();
		}
	};

	return (
		<div className="modal-confirmation">
			{!!formErrorMessage ? (
				<div className="form-validation-error">{formErrorMessage}</div>
			) : (
				<SwitchTransition mode="out-in">
					<CSSTransition key={`key_${isLoading}`} timeout={600} classNames="standalone-fade" mountOnEnter unmountOnExit>
						{isLoading ? (
							<LoadingSpinner show={isLoading} />
						) : (
							<>
								<figure className="icon">
									<AlertIcon />
								</figure>

								<h2 className="heading h4">
									Are you sure you wish to remove{' '}
									<strong>
										'{firstName} {lastName}'?
									</strong>
									<br />
									<br />
									If you remove this person, you will only be able to access a read-only snapshot of their profile in the 'past' tab. This person will no longer have access to your organisation.
								</h2>

								<section className="actions">
									<Button className="btn-primary full-width" onClick={confirmRemove}>
										Yes
									</Button>

									<Button className="btn-secondary full-width" onClick={closeModal}>
										Cancel
									</Button>
								</section>
							</>
						)}
					</CSSTransition>
				</SwitchTransition>
			)}
		</div>
	);
};

export default RemoveFamiliesMemberModal;
